import { Loading } from "@/layouts/loading";
import { createFileRoute } from "@tanstack/react-router";

const ReportsComponent = () => {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-6">Company Reports</h1>
      <div className="bg-white p-6 rounded-lg border shadow-sm">
        <h2 className="text-xl font-semibold mb-4">Company-Wide Reports</h2>
        <p className="text-gray-600 mb-4">
          Access comprehensive reports across all company branches and operations.
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          <div className="bg-blue-50 p-4 rounded-lg">
            <h3 className="font-semibold text-blue-900 mb-2">Financial Reports</h3>
            <p className="text-sm text-blue-700">Revenue, expenses, and profit analysis</p>
          </div>
          <div className="bg-green-50 p-4 rounded-lg">
            <h3 className="font-semibold text-green-900 mb-2">Inventory Reports</h3>
            <p className="text-sm text-green-700">Stock levels and movement tracking</p>
          </div>
          <div className="bg-purple-50 p-4 rounded-lg">
            <h3 className="font-semibold text-purple-900 mb-2">Performance Reports</h3>
            <p className="text-sm text-purple-700">Branch performance and KPI metrics</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export const Route = createFileRoute('/company/_layout/reports/')({
  component: ReportsComponent,
  pendingComponent: () => <Loading />,
})
